import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _listPagesImportedNamespacesRequest = {};
var _listPagesImportedNamespacesResponse = {};
function resolveWixVeloAppsAnalysisV1UserCodeImportedNamespacesUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/cloud-user-code-analyzer',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixVeloAppsAnalysisV1UserCodeImportedNamespacesDevUrl(opts) {
    var domainToMappings = {
        'editor._base_domain_': [
            {
                srcPath: '/_api/cloud-user-code-dev-analyzer',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/cloud-user-code-dev-analyzer',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/cloud-user-code-dev-analyzer',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Bulk API for retrieving the imported namespaces used in a page. */
export function devListPagesImportedNamespaces(payload) {
    var _a = serializer(_listPagesImportedNamespacesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPagesImportedNamespacesResponse, {}).fromJSON;
    function __devListPagesImportedNamespaces(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.velo.apps.v1.page_imported_namespaces',
            method: 'GET',
            methodFqn: 'wix.velo.apps.analysis.v1.UserCodeImportedNamespacesDev.ListPagesImportedNamespaces',
            url: resolveWixVeloAppsAnalysisV1UserCodeImportedNamespacesDevUrl({
                protoPath: '/v1/apps/{gridAppId}/pages-imported-namespaces',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __devListPagesImportedNamespaces.fromReq = fromReq;
    __devListPagesImportedNamespaces.__isAmbassador = true;
    return __devListPagesImportedNamespaces;
}
/** Bulk API for retrieving the imported namespaces used in a page. */
export function listPagesImportedNamespaces(payload) {
    var _a = serializer(_listPagesImportedNamespacesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPagesImportedNamespacesResponse, {}).fromJSON;
    function __listPagesImportedNamespaces(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.velo.apps.v1.page_imported_namespaces',
            method: 'GET',
            methodFqn: 'wix.velo.apps.analysis.v1.UserCodeImportedNamespaces.ListPagesImportedNamespaces',
            url: resolveWixVeloAppsAnalysisV1UserCodeImportedNamespacesUrl({
                protoPath: '/v1/apps/{gridAppId}/pages-imported-namespaces',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPagesImportedNamespaces.fromReq = fromReq;
    __listPagesImportedNamespaces.__isAmbassador = true;
    return __listPagesImportedNamespaces;
}
//# sourceMappingURL=http.impl.js.map